export default class ToolbarItemContainer{

    private data;

    constructor(data: JSX.Element){
        this.data = data;
    }

    getToolbarItem(): JSX.Element{
        return this.data;
    }

}